import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  dashBoardUrls,
  prepareQuotaSubmissoinStatusData,
  prepareConsumptionData,
  prepareScenarioConsumptionData,
} from "./dashboardUtils";

const initialState = {
  drawerOpen: false,
  isLoading: false,
  allDataLoaded: false,
  totalData: 6,
  dataLoaded: 0,
  quotaSubmissionStatusData: [],
  quotaSubmissionStatusDataPrepared: [],
  consumptionByCountry: [],
  scenarioConsumption: [],
  consumptionByCountryPrepared: [],
  scenarioConsumptionPrepared: [],
  geoData: [],
  synchronizationStatus: [],
  scenarioCriticalityList: [],

  countries: [],
  selectedCountry: "",
  selectedCountryID: "",
  selectedCriticality: "",
  selectedCriticalityID: "",
  selectedOrderStatus: "",

  scenario: "",
  scenarios: [],
  scenariosPrepared: [],

  approvalStats: {
    scenarioCount: 0,
    quotaCount: 0,
    quotaModificationsCount: 0,
  },
};

export const getQuotaSubmissionStatusData = createAsyncThunk(
  "dashboard/getQuotaSubmissionStatusData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = dashBoardUrls.quotaSubmittionStatusData + `userId=${userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getConsumptionByCountry = createAsyncThunk(
  "dashboard/getConsumptionByCountry",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = dashBoardUrls.consumptionByCountry + `userId=${userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getGeoData = createAsyncThunk(
  "dashboard/getGeoData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = dashBoardUrls.geoData;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getSynchronizationStatus = createAsyncThunk(
  "dashboard/getSynchronizationStatus",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = dashBoardUrls.synchronizationStatus + `userId=${userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getOrderStatus = createAsyncThunk(
  "dashboard/getOrderStatus",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = dashBoardUrls.orderStatus + `userid=${userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getUserCountries = createAsyncThunk(
  "dashboard/getUserCountries",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = dashBoardUrls.userCountries + `userid=${data.userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarioCriticalityList = createAsyncThunk(
  "dashboard/getScenarioCriticalityList",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = dashBoardUrls.scenarioCriticalityList;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarios = createAsyncThunk(
  "dashboard/getScenarios",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, status, scenario, criticalityId } = obj;
    const url =
      dashBoardUrls.scenarios +
      `countryId=${countryID}&status=${status}&scenario=${scenario}&criticalityId=${criticalityId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getApprovalStats = createAsyncThunk(
  "dashboard/getApprovalStats",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID } = obj;
    const url =
      dashBoardUrls.approvalStats +
      `userid=${data.userID}&countryid=${countryID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const dashBoardSlice = createSlice({
  name: "dashBoard",
  initialState,
  reducers: {
    resetDashboardLoading: (state) => {
      state.allDataLoaded = false;
      state.dataLoaded = 0;
      state.isLoading = true;
    },
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuotaSubmissionStatusData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQuotaSubmissionStatusData.fulfilled, (state, action) => {
        state.quotaSubmissionStatusData =
          action.payload.quotaSubmsnChartDataList;
        state.quotaSubmissionStatusDataPrepared =
          prepareQuotaSubmissoinStatusData(
            action.payload.quotaSubmsnChartDataList
          );

        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getQuotaSubmissionStatusData.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from getQuotaSubmissionStatusData",
          action.error.message
        );
      })
      .addCase(getConsumptionByCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getConsumptionByCountry.fulfilled, (state, action) => {
        state.consumptionByCountry = action.payload.countryConsumptionChart;
        state.scenarioConsumption = action.payload.scenarioConsumptionChart;
        state.consumptionByCountryPrepared = prepareConsumptionData(
          action.payload.countryConsumptionChart
        );
        state.scenarioConsumptionPrepared = prepareScenarioConsumptionData(
          action.payload.scenarioConsumptionChart
        );

        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getConsumptionByCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from getConsumptionByCountry",
          action.error.message
        );
      })
      .addCase(getGeoData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getGeoData.fulfilled, (state, action) => {
        state.geoData = action.payload;
        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getGeoData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getGeoData", action.error.message);
      })
      .addCase(getSynchronizationStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSynchronizationStatus.fulfilled, (state, action) => {
        state.synchronizationStatus = action.payload;
        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getSynchronizationStatus.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from getSynchronizationStatus",
          action.error.message
        );
      })
      .addCase(getOrderStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getOrderStatus.fulfilled, (state, action) => {
        state.orderStatus = action.payload;
        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getOrderStatus.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getOrderStatus", action.error.message);
      })
      .addCase(getUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUserCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.isLoading = false;
        state.dataLoaded += 1;
        if (state.dataLoaded >= state.totalData) {
          state.allDataLoaded = true;
        }
      })
      .addCase(getUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getUserCountries", action.error.message);
      })
      .addCase(getScenarios.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarios.fulfilled, (state, action) => {
        state.scenarios = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenarios.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenarios", action.error.message);
      })
      .addCase(getApprovalStats.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getApprovalStats.fulfilled, (state, action) => {
        state.approvalStats = action.payload;
        state.isLoading = false;
      })
      .addCase(getApprovalStats.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getApprovalStats", action.error.message);
      })

      .addCase(getScenarioCriticalityList.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioCriticalityList.fulfilled, (state, action) => {
        state.scenarioCriticalityList = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenarioCriticalityList.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from getScenarioCriticalityList",
          action.error.message
        );
      });
  },
});

export const { setState, resetDashboardLoading } = dashBoardSlice.actions;

export default dashBoardSlice.reducer;
